import {ErrorStateScheduleEnum} from '../error-state-schedule.enum';

export enum ClientUsersReportResolverErrorStatesEnum {
    GetReportFailed = ErrorStateScheduleEnum.CompanyEmployeesReportResolverStatesStartIndex
}
